
import React from 'react';
import RoleCard from '@/components/RoleCard';
import { UserRole } from '@/types/user';

interface RoleData {
  id: UserRole;
  title: string;
  description: string;
  features: string[];
  accountTier: 'free' | 'paid';
}

interface RolesSectionProps {
  roles: RoleData[];
  setPreviewRole: (role: UserRole) => void;
}

const RolesSection: React.FC<RolesSectionProps> = ({ roles, setPreviewRole }) => {
  return (
    <section className="py-16 md:py-24 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">Find Your Role</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Players Lockeroom serves everyone in the sports community with role-specific features.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {roles.map((role) => (
            <div key={role.id} onClick={() => setPreviewRole(role.id)} className="cursor-pointer">
              <RoleCard
                role={role.id}
                title={role.title}
                description={role.description}
                features={role.features}
                accountTier={role.accountTier}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RolesSection;
